// extracted by mini-css-extract-plugin
module.exports = {"error":"PaymentError_error__bmhJ0"};